/**
 * PageTarifs — PEFEP TECH — v3
 * ---------------------------------------------------------------
 * Mise a jour du 25/07/2026 :
 *
 * 1. Tous les prix sont affiches en GOURDES (montant principal) et
 *    en DOLLARS (equivalent), cote client comme cote developpeur.
 *
 * 2. Grille client alignee sur les produits WooCommerce :
 *    Basique 6 600, Complet 10 600, Premium 13 500, Renouvellement 6 750.
 *    Le plan Complet reste sur sous-domaine ; le Premium ajoute le
 *    domaine personnalise et l'e-mail professionnel.
 *
 * 3. Section paiement simplifiee : le reglement se fait par MonCash
 *    via notre plateforme securisee. Plus de liste de numeros a
 *    recopier (ni NatCash, ni PayPal, ni second numero).
 *
 * Ecrit a plat : pas de fragments, pas de balises <a>, chaque bloc
 * dans sa propre fonction de rendu.
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from './composants/SEO';
import { SEO_PAGES } from './donnees/seoPages';
import RechercheDomaine from './composants/RechercheDomaine';
import './PageTarifs.css';
import Navigation from './composants/Navigation';
import PiedDePage from './composants/PiedDePage';

const LIEN_AFFILIE_HOSTINGER =
  'https://www.hostinger.fr/?REFERRALCODE=KPDISAACPJMG';

const WHATSAPP_PEFEP = '50947376200';

function PageTarifs() {
  const navigate = useNavigate();
  const [segment, setSegment] = useState('client');

  function ouvrirWhatsApp(message) {
    const url =
      'https://wa.me/' + WHATSAPP_PEFEP + '?text=' + encodeURIComponent(message);
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  function ouvrirHostinger() {
    window.open(LIEN_AFFILIE_HOSTINGER, '_blank', 'noopener,noreferrer');
  }

  /* ═══════════════ SEGMENT CLIENT ═══════════════ */

  function rendreOffresClient() {
    return (
      <div>
        <p className="pt-intro">
          Vous etes entrepreneur, eglise, ONG, restaurant ou organisation ?
          Paiement unique, pas d'abonnement. Votre site reste en ligne tant que
          vous renouvelez votre hebergement.
        </p>

        <div className="pt-cartes">
          <div className="pt-carte">
            <h3>Basique</h3>
            <p className="pt-cible">Pour demarrer avec une presence en ligne credible.</p>
            <div className="pt-montant">6 600 HTG</div>
            <div className="pt-equivalent">≈ 49 $ US</div>
            <div className="pt-periode">Paiement unique</div>
            <ul className="pt-liste">
              <li>Site complet genere par IA</li>
              <li>Adresse en .pefep.site incluse</li>
              <li>Hebergement 1 an inclus</li>
              <li>Design adapte a votre secteur</li>
              <li>Acces au tableau de bord</li>
              <li>Modifications illimitees</li>
              <li>Support WhatsApp</li>
              <li className="absent">Domaine personnalise</li>
            </ul>
            <button
              type="button"
              className="pt-action secondaire"
              onClick={function () {
                navigate('/creer-mon-site');
              }}
            >
              Commencer avec Basique
            </button>
          </div>

          <div className="pt-carte vedette">
            <div className="pt-ruban">Le plus choisi</div>
            <h3>Complet</h3>
            <p className="pt-cible">Pour une presence professionnelle complete.</p>
            <div className="pt-montant">10 600 HTG</div>
            <div className="pt-equivalent">≈ 79 $ US</div>
            <div className="pt-periode">Paiement unique</div>
            <ul className="pt-liste">
              <li>Tout le plan Basique</li>
              <li>Adresse en .pefep.site incluse</li>
              <li>SEO de base optimise</li>
              <li>Formulaire de contact actif</li>
              <li>Integration reseaux sociaux</li>
              <li>Support WhatsApp 7 jours</li>
              <li>1 revision incluse</li>
              <li>Certificat SSL inclus</li>
            </ul>
            <button
              type="button"
              className="pt-action"
              onClick={function () {
                navigate('/creer-mon-site');
              }}
            >
              Commencer avec Complet
            </button>
          </div>

          <div className="pt-carte">
            <h3>Premium</h3>
            <p className="pt-cible">Pour une identite de marque a votre nom.</p>
            <div className="pt-montant">13 500 HTG</div>
            <div className="pt-equivalent">≈ 100 $ US</div>
            <div className="pt-periode">Paiement unique</div>
            <ul className="pt-liste">
              <li>Tout le plan Complet</li>
              <li>Nom de domaine personnalise (.com)</li>
              <li>Boite e-mail professionnelle</li>
              <li>Configuration faite par notre equipe</li>
              <li>Image de marque renforcee</li>
              <li>Support prioritaire</li>
            </ul>
            <button
              type="button"
              className="pt-action secondaire"
              onClick={function () {
                navigate('/creer-mon-site');
              }}
            >
              Commencer avec Premium
            </button>
          </div>

          <div className="pt-carte">
            <h3>Renouvellement</h3>
            <p className="pt-cible">Pour garder votre site en ligne annee apres annee.</p>
            <div className="pt-montant">6 750 HTG</div>
            <div className="pt-equivalent">≈ 50 $ US</div>
            <div className="pt-periode">Par an</div>
            <ul className="pt-liste">
              <li>Renouvellement de l'hebergement</li>
              <li>Site maintenu en ligne</li>
              <li>Sauvegarde automatique</li>
              <li>Support technique inclus</li>
              <li>Mises a jour de securite</li>
              <li className="absent">Refonte du design</li>
            </ul>
            <button
              type="button"
              className="pt-action secondaire"
              onClick={function () {
                ouvrirWhatsApp('Bonjour PEFEP Site, je souhaite renouveler mon site.');
              }}
            >
              Renouveler mon site
            </button>
          </div>
        </div>

        <p className="pt-note-renouvellement">
          Le renouvellement a 6 750 HTG couvre l'hebergement et votre adresse
          .pefep.site. Pour un domaine personnalise, le renouvellement du domaine
          s'ajoute selon l'extension choisie — nous vous communiquons le montant
          exact.
        </p>
      </div>
    );
  }

  /* ═══════════════ SEGMENT DEVELOPPEUR ═══════════════ */

  function rendreOffresDev() {
    return (
      <div>
        <p className="pt-intro">
          Vous etes developpeur, freelance ou agence ? Aucun abonnement
          obligatoire. Vous generez, vous livrez, vous facturez votre client au
          prix que vous decidez.
        </p>

        <div className="pt-cartes">
          <div className="pt-carte">
            <h3>Essai gratuit</h3>
            <p className="pt-cible">Pour juger la qualite avant tout engagement.</p>
            <div className="pt-montant">0 HTG</div>
            <div className="pt-equivalent">Gratuit</div>
            <div className="pt-periode">Sans carte bancaire</div>
            <ul className="pt-liste">
              <li>3 sites generes</li>
              <li>Acces a tous les secteurs</li>
              <li>Apercu complet du resultat</li>
              <li className="absent">Publication</li>
              <li className="absent">Export du code</li>
            </ul>
            <button
              type="button"
              className="pt-action secondaire"
              onClick={function () {
                navigate('/inscription');
              }}
            >
              Essayer gratuitement
            </button>
          </div>

          <div className="pt-carte">
            <h3>Projet a l'unite</h3>
            <p className="pt-cible">Pour un besoin ponctuel, sans engagement.</p>
            <div className="pt-montant">4 725 HTG</div>
            <div className="pt-equivalent">≈ 35 $ US</div>
            <div className="pt-periode">Par projet</div>
            <ul className="pt-liste">
              <li>1 site publiable</li>
              <li>Export du code source</li>
              <li>Hebergement libre</li>
              <li>Support WhatsApp</li>
            </ul>
            <button
              type="button"
              className="pt-action secondaire"
              onClick={function () {
                navigate('/developpeur');
              }}
            >
              Acheter un projet
            </button>
          </div>

          <div className="pt-carte vedette">
            <div className="pt-ruban">Meilleur rapport</div>
            <h3>Pack 10 projets</h3>
            <p className="pt-cible">Pour un flux regulier de clients.</p>
            <div className="pt-montant">33 750 HTG</div>
            <div className="pt-equivalent">≈ 250 $ US — soit 25 $ le projet</div>
            <div className="pt-periode">Credits sans expiration</div>
            <ul className="pt-liste">
              <li>10 sites publiables</li>
              <li>Export du code source</li>
              <li>Credits sans expiration</li>
              <li>Support prioritaire</li>
              <li>Economie de 100 $</li>
            </ul>
            <button
              type="button"
              className="pt-action"
              onClick={function () {
                navigate('/developpeur');
              }}
            >
              Choisir le pack 10
            </button>
          </div>

          <div className="pt-carte">
            <h3>Agency</h3>
            <p className="pt-cible">Pour les agences a fort volume.</p>
            <div className="pt-montant">13 365 HTG</div>
            <div className="pt-equivalent">≈ 99 $ US par mois</div>
            <div className="pt-periode">Sites illimites</div>
            <ul className="pt-liste">
              <li>Generations illimitees</li>
              <li>Export du code source</li>
              <li>Support prioritaire</li>
              <li>Acces anticipe aux nouveautes</li>
              <li>Resiliable a tout moment</li>
            </ul>
            <button
              type="button"
              className="pt-action secondaire"
              onClick={function () {
                navigate('/developpeur');
              }}
            >
              Passer en Agency
            </button>
          </div>
        </div>

        <div className="pt-encart">
          <h3>Business Plus — hebergement et domaine sur mesure</h3>
          <p>
            Aucun forfait developpeur ne couvre l'hebergement ni le nom de
            domaine. Si vous preferez confier cette partie a PEFEP Site,
            decrivez-nous votre volume et nous construisons une offre adaptee.
            Sinon, hebergez vous-meme : nous vous indiquons ou.
          </p>
          <div className="pt-encart-actions">
            <button
              type="button"
              className="pt-action"
              onClick={function () {
                ouvrirWhatsApp(
                  'Bonjour PEFEP Site, je suis developpeur et je souhaite une offre Business Plus (hebergement + domaine).'
                );
              }}
            >
              Demander une offre Business Plus
            </button>
            <button type="button" className="pt-action secondaire" onClick={ouvrirHostinger}>
              Prendre mon hebergement
            </button>
          </div>
        </div>
      </div>
    );
  }

  /* ═══════════════ AFFICHAGE ═══════════════ */

  return (
    <div className="pt-page">
      <SEO {...SEO_PAGES.tarifs} />
      <Navigation />

      <section className="pt-entete">
        <span className="pt-etiquette">Tarifs transparents</span>
        <h1>Des prix clairs, sans surprise</h1>
        <p>
          Payez une fois et votre site est en ligne. Choisissez l'offre qui
          correspond a votre profil, et voyez le cout de renouvellement des le
          depart.
        </p>
      </section>

      <div className="pt-segments">
        <button
          type="button"
          className={segment === 'client' ? 'pt-segment actif' : 'pt-segment'}
          onClick={function () {
            setSegment('client');
          }}
        >
          Entrepreneur, ONG, eglise
        </button>
        <button
          type="button"
          className={segment === 'dev' ? 'pt-segment actif' : 'pt-segment'}
          onClick={function () {
            setSegment('dev');
          }}
        >
          Developpeur ou agence
        </button>
      </div>

      <section className="pt-offres">
        {segment === 'client' ? rendreOffresClient() : rendreOffresDev()}
      </section>

      <section className="pt-domaine">
        <h2>Votre nom de domaine</h2>
        <p className="pt-domaine-note">
          Fini les grilles de prix approximatives. Verifiez la disponibilite de
          votre domaine et voyez son tarif reel, ainsi que son cout de
          renouvellement. Beaucoup d'extensions sont bon marche la premiere annee
          puis nettement plus cheres ensuite : nous affichons les deux.
        </p>
        <RechercheDomaine
          titre="Verifiez la disponibilite"
          sousTitre="Tapez le nom de votre entreprise, sans extension."
        />
      </section>

      <section className="pt-paiement">
        <h2>Un paiement simple et securise</h2>
        <div className="pt-paiement-carte">
          <div className="pt-paiement-titre">Reglez avec MonCash</div>
          <p className="pt-paiement-texte">
            Le paiement se fait en ligne, en gourdes, via MonCash, sur notre
            plateforme de paiement securisee. Apres validation, votre site est
            mis en ligne en 24 h max. Pour la diaspora, MonCash International est
            egalement accepte.
          </p>
          <div className="pt-apres">
            Une question sur le paiement ? Ecrivez-nous sur WhatsApp au
            +509 4737 6200.
          </div>
        </div>
      </section>
      <PiedDePage />
    </div>
  );
}

export default PageTarifs;